import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, HStack } from '@rtkwlf/fenrir-react';
import { faFilter } from '@rtkwlf/pro-solid-svg-icons/faFilter';
import type { Ticket } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';

import { ContactConciergeLink } from 'ae-components/contact/contact-concierge-link';
import type { HeaderType } from 'ae-components/header/Header';
import { Header } from 'ae-components/header/Header';

import { TicketExport } from './ticket-export';

type TicketListHeaderProps = {
  showFilter: boolean;
  toggleFilter: () => void;
  isLoading?: boolean;
  filteredData?: Required<Ticket>[];
};

export const TicketListHeader: React.FC<TicketListHeaderProps> = ({
  showFilter,
  toggleFilter,
  isLoading,
  filteredData,
}) => {
  const { t } = useTranslation();

  const header: HeaderType = {
    titleArgs: { ticketNumber: filteredData?.length },
    titleKey: 'ticket:titleWithNumber',
  };

  return (
    <Header
      isLoading={isLoading}
      details={header}
      alignItems="center"
      paddingX="large"
    >
      <HStack gap="small">
        <Button
          variant="tertiary"
          onClick={toggleFilter}
          iconLeft={<FontAwesomeIcon icon={faFilter} />}
        >
          {showFilter ? t('filter:hideFilter') : t('filter:showFilter')}
        </Button>

        <TicketExport data={filteredData} />

        <ContactConciergeLink variant="primary" iconLeft={null}>
          {t('filter:newTicket')}
        </ContactConciergeLink>
      </HStack>
    </Header>
  );
};
